import { Controller } from '@hotwired/stimulus'
import { debug } from '../utils/debug'

/**
 * FAQ Vote Controller
 *
 * Handles FAQ helpful/not helpful voting with optimistic UI updates.
 *
 * Usage:
 * <div data-controller="faq-vote" data-faq-vote-id-value="123">
 *   <a href="#" data-action="click->faq-vote#upvote">Yes</a>
 *   <a href="#" data-action="click->faq-vote#downvote">No</a>
 * </div>
 */
export default class extends Controller {
  static values = {
    id: Number,
    upvoteUrl: String,
    downvoteUrl: String
  }

  async upvote(event) {
    event.preventDefault()
    await this.vote(this.upvoteUrlValue)
  }

  async downvote(event) {
    event.preventDefault()
    await this.vote(this.downvoteUrlValue)
  }

  async vote(url) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    // Optimistic UI update
    this.element.innerHTML = 'Thank you for voting!'

    debug('faq-vote', 'Submitting vote', { url })

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': csrfToken,
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'text/vnd.turbo-stream.html, text/html, application/json'
        },
        credentials: 'include'
      })

      if (response.ok) {
        debug('faq-vote', 'Vote recorded successfully')
      } else {
        debug('faq-vote', 'Vote failed', { status: response.status })
        // Could revert UI here if needed
      }
    } catch (error) {
      debug('faq-vote', 'Vote error', error)
    }
  }
}

